import { Guid } from "@shared/utils/guid.helper";
import { ChangeAuthorisation } from "./change-authorisation";
import { Company } from "../companies/company";
import { DocumentNotificationDetails } from "./document-notification-details";
import { EntityChangeData } from "./entity-change-data";
import { ReminderRecord } from "../reminders/reminder-record";
import { DocumentSigning } from "./document-signing";

export class DocumentBase {
    documentId: string;
    organisationId?: string;
    company: Company;
    entityId: string | null;
    changes: EntityChangeData[];
    changeAuthorisation?: ChangeAuthorisation
    type: string;
    description?: string;
    name: string;
    documentSigning?: DocumentSigning | null;
    createdOn: Date | undefined;
    modifiedOn: Date | undefined;
    reminders: ReminderRecord[];
    notificationDetails?: DocumentNotificationDetails | null;

    constructor(data: Partial<DocumentBase> = {}) {
        this.documentId = data?.documentId ?? Guid.EmptyGuid;
        this.organisationId = data?.organisationId;
        this.entityId = data.entityId ?? null;
        this.company = data.company ? new Company(data.company) : {} as Company;
        this.changes = data?.changes ?? [];
        this.changeAuthorisation = data?.changeAuthorisation;
        this.type = data.type ?? '';
        this.description = data?.description;
        this.name = data.name ?? '';
        this.documentSigning = data?.documentSigning ? new DocumentSigning(data?.documentSigning) : null;
        this.createdOn = data.createdOn ? new Date(data.createdOn) : undefined;
        this.modifiedOn = data.modifiedOn ? new Date(data.modifiedOn) : undefined;
        this.reminders = data.reminders ?? [];
        this.notificationDetails = data.notificationDetails ?? null;
    }
}
